/**
 * Registry of frontend page keys returned by GET /permissions/my-pages.
 * Keep in sync with FRONTEND_PAGE_KEYS in backend/app/api/permissions.py.
 */
export const FRONTEND_PAGE_KEYS = [
  'admin',
  'homehub',
  'settings',
  'claimshire',
  'kpidashboard',
  'highlevelstats',
  'request',
  'referral-details',
  'source-rates',
  'rates',
  'aiclaims-dashboard',
  'aiclaims-cases',
  'aiclaims-workflows',
  'aiclaims-runs',
  'aiclaims-call-analysis',
  'aiclaims-call-auditing',
  'admin-users',
  'admin-role-allocations',
  'admin-role-permissions',
  'admin-invoices',
  'admin-invoice-processing',
  'admin-user-partners',
  'admin-partners',
  'admin-partner-rules',
  'admin-flow-triggers',
  'admin-ai-prompt-config',
  'admin-report-templates',
  'admin-rate-limiting',
  'admin-app-settings',
  'admin-privacy-settings',
  'admin-metabase-reports',
  'admin-task-scheduler',
  'admin-schedule-builder',
  'admin-database',
  'admin-workflows',
  'admin-run-inspector',
  'admin-workflow-compare',
  'admin-workflow-feedback-runs',
  'admin-partner-issue-insights',
  'admin-bulk-summaries',
  'admin-security-tests',
  'demo',
  'aiclaims-demo',
  'auth-test',
] as const

export type FrontendPageKey = (typeof FRONTEND_PAGE_KEYS)[number]
